import { type FC } from "react";
import { AvatarMale } from "@/components/logos/AvatarMale";
import { AvatarFemale } from "@/components/logos/AvatarFemale";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface PersonaImageAvatarProps {
  src?: string;
  altText: string;
  gender?: string;
  className?: string;
  onClick?: () => void;
}

export const PersonaImageAvatar: FC<PersonaImageAvatarProps> = ({
  src,
  altText,
  gender = "female",
  className,
  onClick,
}) => {
  return (
    <Avatar className={className} onClick={onClick}>
      <AvatarImage className="object-cover" src={src} alt={altText} />
      <AvatarFallback>
        {gender === "male" ? <AvatarMale /> : <AvatarFemale />}
      </AvatarFallback>
    </Avatar>
  );
};
